import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";

export const Tab = styled.div`
    ${p =>
        p.theme.md.min(css`
            padding: 12px 24px;
            width: 700px;
        `)}
    margin: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 32px;
    ${p =>
        p.theme.xs(css`
            grid-template-columns: 1fr;
            padding-bottom: 4px;
        `)}
`;

export const Card = styled.div`
    display: inline-block;
    background-color: ${p => p.theme.c.active};
    padding: 4px 8px 5px;
    border-radius: 4px;
    margin: 4px;
    color: ${p => p.theme.c.snow};
    font-size: 14px;

    &.Disabled {
        background-color: ${p => p.theme.c.disabled};
    }
`;

export const StyledABCname = styled(Card)`
    color: ${p => p.theme.c.active};
    background-color: ${p => p.theme.c.white};
    border: 1px solid ${p => p.theme.c.active};
`;

export const StyledForm = styled.form`
    display: inline-block;
`;

export const NavElement = styled(NavLink)`
    display: block;
    margin: 0;
    font-size: 20px;
    font-weight: 400;
    padding: 8px 10px;
    cursor: pointer;
    margin-bottom: 16px;
    color: ${p => p.theme.mode === "dark" ? p.theme.c.whiteOnActive : p.theme.c.grey7};
    border-radius: 8px;

    &.Active {
        color: ${p => p.theme.c.whiteOnActive};
        background-color: ${p => p.theme.c.active};
    }
`;

export const Nav = styled.div`
    display: block;
    ${p =>
        p.theme.md.min(css`
            width: 220px;
        `)}
    overflow-x: auto;
`;

export const StyledMeta = styled.div`
    min-height: calc(100vh - 420px);
    ${p =>
        p.theme.md.min(css`
            display: flex;
        `)}
`;

export const Page = styled.div`
    flex: 1;
`;
